<nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-blue">
    <div class="container-fluid">
        <div class="row" style="width: 100%;">
            <div class="col col-home">
                <a class="navbar-brand me-auto me-lg-0" [routerLink]="routerLinkArray">
                    <fa-icon [icon]="icons['faArrowLeft']"></fa-icon> Home
                </a>
            </div>
            <div class="col text-center col-orgname">
                <nav class="navbar-light p-0 ps-3 pt-1 text-center" *ngIf="orgName">
                    <span class="navbar-brand mb-0 h1">{{orgName}}</span>
                </nav>
            </div>
            <div class="col col-languages">
                <ul class="nav justify-content-end" id="main-navigation">
                  <li class="nav-item">
                    <a class="nav-link" (click)="onLogout()" tabindex="-1" aria-disabled="true">
                        {{'NAVBAR.logout'| translate}}
                    </a>
                  </li>
                  <li class="nav-item dropdown">
                      <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
                          data-bs-toggle="dropdown" aria-expanded="false">
                          <ng-container [ngSwitch]="translate.currentLang">
                              <ng-container *ngSwitchCase="'de'">
                                  {{'NAVBAR.german'| translate}}
                              </ng-container>
                              <ng-container *ngSwitchCase="'it'">
                                  {{'NAVBAR.italian'| translate}}
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                  {{'NAVBAR.english'| translate}}
                              </ng-container>
                          </ng-container>
                      </a>
                      <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                          <a class="dropdown-item" (click)="onLanguageChangeClick('de')"
                              [hidden]="'de' === translate.currentLang">{{'NAVBAR.german'| translate}}</a>
                          <a class="dropdown-item" (click)="onLanguageChangeClick('it')"
                              [hidden]="'it' === translate.currentLang">{{'NAVBAR.italian'| translate}}</a>
                          <!-- <a class="dropdown-item" (click)="onLanguageChangeClick('en')"
                          [hidden]="'en' === translate.currentLang">{{'NAVBAR.english'| translate}}</a> -->
                      </div>
                  </li>
                </ul>
            </div>
        </div>
    </div>
</nav>

<main role="main">
    <router-outlet></router-outlet>
</main>
